import SplitText from "../../../common/SplitText";

const bg = process.env.PUBLIC_URL + '/images/story.webp';

export default function Story() {
    return (
        <div id='about' className='bg-gradient-to-b from-[#FAFDFB] via-[#F4FAF6] to-[#EAF6F0] py-[60px] sm:py-[90px] px-[16px] sm:px-[24px] lg:px-[40px] mt-0 scroll-mt-20'>
            <div className='w-11/12 max-w-[1360px] mx-auto flex flex-col items-center'>
                
                {/* Header */}
                <div className='inline-block text-[#181F38] text-[15px] sm:text-[17px] font-bold mb-1.5 tracking-wide'>
                    About Us
                </div>

                {/* Title with Festive Rays */}
                <div className='flex items-center justify-center gap-3 sm:gap-5'>
                    {/* Left Festive Sparkle Rays */}
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" className="shrink-0 -rotate-12 hidden sm:block">
                        <line x1="14" y1="2" x2="14" y2="8" stroke="#FFD028" strokeWidth="2.5" strokeLinecap="round" />
                        <line x1="4" y1="8" x2="8" y2="12" stroke="#34C759" strokeWidth="2.5" strokeLinecap="round" />
                        <line x1="2" y1="18" x2="8" y2="16" stroke="#0099FF" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>

                    <SplitText
                        text="The Rainbow Trucks Story"
                        tag="h2"
                        className='text-[#181F38] text-[28px] sm:text-[38px] lg:text-[46px] xl:text-[52px] font-bold text-center'
                        delay={30}
                        duration={0.6}
                        ease="power3.out"
                        splitType="words, chars"
                        from={{ opacity: 0, y: 30 }}
                        to={{ opacity: 1, y: 0 }}
                        threshold={0.1}
                        rootMargin="-40px"
                        textAlign="center"
                    />

                    {/* Right Festive Sparkle Rays */}
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" className="shrink-0 rotate-12 hidden sm:block">
                        <line x1="14" y1="2" x2="14" y2="8" stroke="#FFD028" strokeWidth="2.5" strokeLinecap="round" />
                        <line x1="24" y1="8" x2="20" y2="12" stroke="#34C759" strokeWidth="2.5" strokeLinecap="round" />
                        <line x1="26" y1="18" x2="20" y2="16" stroke="#0099FF" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                </div>

                {/* Rainbow Divider Accent Bar */}
                <div className='flex items-center justify-center gap-1.5 mt-3 mb-10'>
                    <span className='w-7 h-1.5 rounded-full bg-[#FF4E42]'></span>
                    <span className='w-7 h-1.5 rounded-full bg-[#FFA114]'></span>
                    <span className='w-7 h-1.5 rounded-full bg-[#FFD028]'></span>
                    <span className='w-7 h-1.5 rounded-full bg-[#34C759]'></span>
                    <span className='w-7 h-1.5 rounded-full bg-[#0099FF]'></span>
                    <span className='w-7 h-1.5 rounded-full bg-[#8E52FF]'></span>
                </div>

                {/* Main 3-Column Layout: Left Cards, Center Cart Illustration, Right Cards */}
                <div className='w-full grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 items-center'>
                    
                    {/* Left Column (Cards 1 & 3) */}
                    <div className='lg:col-span-4 flex flex-col gap-6'>
                        
                        {/* Top Left Card: From a Local Kulfi Dream */}
                        <div className='bg-white rounded-[26px] p-6 sm:p-7 border border-gray-100/90 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex flex-col text-left'>
                            <div className='size-[52px] rounded-full bg-[#EBF7EE] flex items-center justify-center text-[#34C759] mb-4'>
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>
                                    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
                                </svg>
                            </div>
                            <div className='mb-3'>
                                <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold'>
                                    From a Local Kulfi Dream
                                </h3>
                                <div className='w-8 h-0.5 bg-[#34C759] rounded-full mt-1.5'></div>
                            </div>
                            <p className='text-[#475569] text-[14px] sm:text-[15px] font-normal leading-relaxed'>
                                Rainbow Trucks – Fresh Kulfi started as a local kulfi business in Tamil Nadu, and today, it has become a promising franchise opportunity with a strong brand and proven business model.
                            </p>
                        </div>

                        {/* Bottom Left Card: Our Vision */}
                        <div className='bg-white rounded-[26px] p-6 sm:p-7 border border-gray-100/90 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex flex-col text-left'>
                            <div className='size-[52px] rounded-full bg-[#EBF7EE] flex items-center justify-center text-[#34C759] mb-4'>
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                    <circle cx="9" cy="7" r="4"/>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                </svg>
                            </div>
                            <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold mb-3'>
                                Our Vision
                            </h3>
                            <p className='text-[#475569] text-[14px] sm:text-[15px] font-normal leading-relaxed'>
                                Our vision is to create <strong className='text-[#181F38] font-bold'>1,000 rural entrepreneurs by 2030</strong>, empowering small-town and rural communities with business opportunities that are easy to operate and scale.
                            </p>
                        </div>
                    </div>

                    {/* Center Column: Rainbow Truck Cart Illustration */}
                    <div className='lg:col-span-4 flex flex-col items-center justify-center relative py-4'>
                        {/* Sun glow & ambient backdrop */}
                        <div className='absolute w-[240px] sm:w-[280px] h-[240px] sm:h-[280px] bg-[#FFF2D6] rounded-full blur-[60px] -top-2 left-6 pointer-events-none opacity-80' />
                        <div className='relative z-10 w-full max-w-[340px] sm:max-w-[400px] flex items-center justify-center'>
                            <img 
                                src={bg} 
                                alt='The Rainbow Trucks Story Kulfi Cart' 
                                className='w-full max-h-[380px] object-contain drop-shadow-xl hover:scale-105 transition-transform duration-500'
                            />
                        </div>
                    </div>

                    {/* Right Column (Cards 2 & 4) */}
                    <div className='lg:col-span-4 flex flex-col gap-6'>
                        
                        {/* Top Right Card: Three Flexible Cart Options */}
                        <div className='bg-white rounded-[26px] p-6 sm:p-7 border border-gray-100/90 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex flex-col text-left'>
                            <div className='size-[52px] rounded-full bg-[#E8F3FD] flex items-center justify-center text-[#2563EB] mb-4'>
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="8" cy="21" r="1"/>
                                    <circle cx="19" cy="21" r="1"/>
                                    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
                                </svg>
                            </div>
                            <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold mb-3'>
                                Three Flexible Cart Options
                            </h3>
                            <p className='text-[#475569] text-[14px] sm:text-[15px] font-normal leading-relaxed'>
                                We offer three flexible cart options—designed for various <strong className='text-[#181F38] font-bold'>budgets and locations</strong>—to empower entrepreneurs to run successful, profitable businesses.
                            </p>
                        </div>

                        {/* Bottom Right Card: More Than Just Kulfi */}
                        <div className='bg-white rounded-[26px] p-6 sm:p-7 border border-gray-100/90 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex flex-col text-left'>
                            <div className='size-[52px] rounded-full bg-[#E8F3FD] flex items-center justify-center text-[#2563EB] mb-4'>
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
                                    <polyline points="16 7 22 7 22 13"/>
                                </svg>
                            </div>
                            <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold mb-3'>
                                More Than Just Kulfi
                            </h3>
                            <p className='text-[#475569] text-[14px] sm:text-[15px] font-normal leading-relaxed'>
                                Rainbow Trucks isn't just about selling kulfi; it's about <strong className='text-[#181F38] font-bold'>creating economic opportunities</strong> and fostering sustainable growth in local communities.
                            </p>
                        </div>
                    </div>

                </div>

                {/* Bottom Full-Width Highlight Banner */}
                <div className='w-full mt-8 bg-gradient-to-r from-[#FAF5FF] via-[#FDF9FE] to-[#F5EEFD] rounded-[24px] p-5 sm:p-6 border border-[#E9D7FE] shadow-sm flex flex-col sm:flex-row items-center justify-between gap-5 text-left relative overflow-hidden'>
                    <div className='flex items-center gap-4 sm:gap-5 z-10'>
                        <div className='size-[48px] sm:size-[52px] rounded-full bg-[#8E52FF] text-white flex items-center justify-center shrink-0 shadow-md'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
                            </svg>
                        </div>
                        <p className='text-[#475569] text-[14px] sm:text-[16px] leading-relaxed max-w-[860px]'>
                            Many of our franchisees use this opportunity as their primary source of income, while others rely on it as a secondary income stream to <strong className='text-[#6B21A8] font-bold'>support their family needs.</strong>
                        </p>
                    </div>

                    {/* Subtle Family Line Art on Right */}
                    <div className='hidden md:flex items-center gap-2 opacity-50 shrink-0 text-[#8E52FF]'>
                        <svg width="120" height="55" viewBox="0 0 120 55" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M85 50V32l16-10 12 7v21H85z" />
                            <path d="M95 50V38h7v12" />
                            <circle cx="18" cy="18" r="5.5" />
                            <path d="M9 44v-7a7 7 0 0 1 14 0v7" />
                            <circle cx="38" cy="16" r="5.5" />
                            <path d="M29 44v-9a7 7 0 0 1 14 0v9" />
                            <circle cx="28" cy="27" r="4" />
                            <path d="M22 50v-5a5 5 0 0 1 10 0v5" />
                        </svg>
                    </div>
                </div>

            </div>
        </div>
    )
}
